import React from 'react';
import { Outlet } from 'react-router-dom';
import { Navbar, Footer } from '../components';
import { useScrollToTop } from '../hooks/useScrollToTop';

const MainLayout: React.FC = () => {
  // Use the scroll to top hook to ensure pages start at the top
  useScrollToTop();
  
  return (
    <div className="min-h-screen flex flex-col">
      <Navbar />
      <main className="flex-grow pt-[var(--header-total-height)] bg-background-primary transition-colors duration-200">
        <div className="h-full">
          <Outlet />
        </div>
      </main>
      <Footer />
    </div>
  );
};

export default MainLayout; 